import parseDomain from "./parseDomain"

export default (domain, filter) => {
    filter = filter.replace(/\s+$/, '').replace(/^\s+/, '')
    var filterParsed = parseDomain(filter)
    domain = "." + domain
    filter = "." + filter
    if (filterParsed !== null) {
        filterParsed = "." + filterParsed
    }
    return (filter == "" || domain.includes(filter) || (filterParsed !== null && filterParsed !== filter && domain.includes(filterParsed)))
}
